export default __webpack_public_path__ + "static/media/tutorial-step-3.aacc86a6.png";